import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children }) => {
  const { token: reduxToken } = useSelector((state) => state.AuthReducer);
  const location = useLocation();


  const token = reduxToken || sessionStorage.getItem('admin-token');

  if (!token) {

    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;











//  Please done remove the above code, it is the old code. I have updated the code in the MainIndex.js file, you can check that.
// import React from 'react';
// import { Navigate, useLocation } from 'react-router-dom';
// import { useSelector } from 'react-redux';

// const ProtectedRoute = ({ children }) => {
//     const { token } = useSelector((state) => state.AuthReducer);
//     const location = useLocation();

//     if (!token) {
//         return <Navigate to="/sign-in" state={{ from: location }} replace />;
//     }

//     return children;
// };

// export default ProtectedRoute;

